<template>
  <v-alert
    type="info"
    :icon="false"
    prominent
  >
    <h4 class="text-h6 mb-2">
      {{ $t('Verify your email address') }}
    </h4>
    <div class="mb-3">
      <p>{{ $t('We have sent you an email to verify your email address!') }}</p>
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="daysLeft > 9"
        v-html="$t('You need to verify your email address <b>within {days} days</b> of your registration to prevent your account from being disabled.', { days: daysLeft })"
      />
      <p
        v-else-if="daysLeft <= 9"
        v-html="$t('You need to verify your email address <b>within {days} days</b> to prevent your account from being disabled.', { days: daysLeft })"
      />
      <p>
        {{ $t('Please check your inbox for a verification email.') }}<br>
        <small>{{ $t("If it isn't in your inbox, check your folders. If a spam filter or email rule moved the email, it might be in the Spam, Junk, Trash, Deleted Items, or Archive folder") }}</small>
      </p>
      <!-- eslint-enable vue/no-v-html -->
    </div>

    <div class="d-flex">
      <v-spacer />
      <v-btn
        class="pull-right"
        color="primary"
        :loading="form.processing"
        :disabled="form.processing"
        @click="resendLink"
      >
        {{ $t('Resend email') }}
      </v-btn>
    </div>

    <!-- <v-row align="center">
      <v-col
        :cols="$vuetify.breakpoint.xsOnly ? 12 : null"
        :sm="$vuetify.breakpoint.xsOnly ? 6 : null"
        :class="{'grow': $vuetify.breakpoint.smAndUp}"
      >
        {{ $t('You must verify your email before continuing. Please check your inbox for a verification email.') }}<br>
        <small>{{ $t("If it isn't in your inbox, check your folders. If a spam filter or email rule moved the email, it might be in the Spam, Junk, Trash, Deleted Items, or Archive folder") }}</small>
      </v-col>
      <v-col
        :cols="$vuetify.breakpoint.xsOnly ? 12 : null"
        :sm="$vuetify.breakpoint.xsOnly ? 6 : null"
        :class="{'shrink': $vuetify.breakpoint.smAndUp}"
      >
        <v-btn
          color="primary"
          :loading="form.processing"
          :disabled="form.processing"
          @click="resendLink"
        >
          {{ $t('Resend email') }}
        </v-btn>
      </v-col>
    </v-row> -->
  </v-alert>
</template>

<script>
export default {
  props: {
    daysLeft: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({})
    }
  },

  methods: {
    resendLink() {
      this.form.post(this.route('verification.send'));
    }
  }
}
</script>